import React from "react";
import { useTranslation } from "react-i18next";

const Nomatch = () => {
  const { t: tCommon } = useTranslation("common");
  return <div>{tCommon("error._404")}</div>;
};

export default Nomatch;
